import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function PrivateRoute({ component: Component, ...rest }) {
  const { currentUser, hasAccess, loading } = useAuth();

  if (loading) return null;
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!currentUser) {
          return <Redirect to="/login" />;
        }
        if (!hasAccess && !currentUser.isSuperuser) {
          return <Redirect to="/payment" />;
        }
        return <Component {...props} />;
      }}
    />
  );
}